// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3iKUT","label":"styles_label__kAVkc"};